import React from 'react';
import styles from "./map.module.scss";
import Heading from './Heading/heading';

const MapSection = () => {
    return (
        <>
          <Heading/> 
          <div className={styles.container2}>
          <div className={styles.mapsection}>
             <img src="/assets/map1.png"  className="imgFluid"/>
          </div>
          </div> 
        </>
    )
}

export default MapSection;
